// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"ImageModal-module__modalHeader___32gXs","container":"ImageModal-module__container___2JzyT","copyright":"ImageModal-module__copyright___3KGZ9"};